"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useInquiryForm } from "./useInquiryForm";
import { BookingFormFields } from "./BookingFormFields";
import { SummaryModal } from "./SummaryModal";
import { PaymentModal } from "./PaymentModal";
import type { InquiryFormProps } from "./types";
import { partialPaymentAmount } from "@/lib/booking/partial-payment";

export function InquiryForm({ embedded = false }: InquiryFormProps) {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    errors,
    allFields,
    slots,
    availableToOptions,
    horario,
    horarioHasta,
    pricing,
    loading,
    showSummaryModal,
    showPaymentModal,
    summaryData,
    payPartial,
    payAmount,
    onSubmit,
    setShowSummaryModal,
    setShowPaymentModal,
    handleModalConfirm,
    startPayment,
    setPayPartial,
    setPayAmount,
  } = useInquiryForm();

  const formContent = (
    <BookingFormFields
      register={register}
      control={control}
      setValue={setValue}
      errors={errors}
      allFields={allFields}
      slots={slots}
      availableToOptions={availableToOptions}
      horario={horario}
      horarioHasta={horarioHasta}
      pricing={pricing}
      onSubmit={handleSubmit(onSubmit)}
    />
  );

  return (
    <>
      <div className={embedded ? "w-full" : "w-full max-w-3xl mx-auto"}>
        {embedded ? (
          formContent
        ) : (
          <motion.main className="bg-white rounded-3xl shadow p-6">
            {formContent}
          </motion.main>
        )}
      </div>

      <AnimatePresence>
        {showSummaryModal && summaryData && pricing && (
          <SummaryModal
            summaryData={summaryData}
            pricing={pricing}
            allFields={allFields}
            onClose={() => setShowSummaryModal(false)}
            onConfirm={handleModalConfirm}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showPaymentModal && pricing && (
          <PaymentModal
            pricing={pricing}
            payPartial={payPartial}
            payAmount={payAmount}
            loading={loading}
            onClose={() => setShowPaymentModal(false)}
            onPayPartialChange={(checked) => {
              setPayPartial(checked);
              const amt = checked
                ? partialPaymentAmount(pricing.totalAmount)
                : pricing.totalAmount;
              setPayAmount(amt);
              setValue("monto", amt);
            }}
            onStartPayment={startPayment}
          />
        )}
      </AnimatePresence>
    </>
  );
}
